import { render, staticRenderFns } from "./ClientAccounts.vue?vue&type=template&id=ee2c947c&scoped=true&"
import script from "./ClientAccounts.vue?vue&type=script&lang=js&"
export * from "./ClientAccounts.vue?vue&type=script&lang=js&"
import style0 from "./ClientAccounts.vue?vue&type=style&index=0&id=ee2c947c&prod&lang=scss&"
import style1 from "./ClientAccounts.vue?vue&type=style&index=1&id=ee2c947c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2c947c",
  null
  
)

export default component.exports